<div [agprLoading]="!defaultFilters">
    <h5
        [id]="id + '_userPreferenceFilterWrapper_defaultFilterLabel'"
        class="agpr-userPreferences-subSection-subHeading"
    >
        {{'AccountPreferences.defaultFilter' | localize}}
    </h5>
    <div class="agpr-userPreferences-container">
        <div>
            <!-- HACK: We ngIf between the two so that a dropdown is shown during loading, but not the lhp-default-filter dropdown
                which uses the filter service and needs data so as not to error -->
            <agpr-filter-dropdown
                *ngIf="!defaultFilters"
                [id]="id + '.userPreferences.filters.loading'"
                quickFilterPlaceholder='AccountPreferences.contentFilter.placeholder'
                [showQuickFilter]="true"
                [showSelectedFilters]="true"
                [ariaLabelledBy]="id + '_userPreferenceFilterWrapper_defaultFilterLabel'"
            ></agpr-filter-dropdown>
            <agpr-left-hand-panel-default-filter
                *ngIf="defaultFilters"
                [id]="id + '.userPreferences.filters'"
                [defaultFilters]="defaultFilters"
                [items]="items"
                [initialValues]="initialValues"
                [ariaLabelledBy]="id + '_userPreferenceFilterWrapper_defaultFilterLabel'"
                (filterChange)="filterChange.emit()"
            ></agpr-left-hand-panel-default-filter>
        </div>
    </div>
</div>
